import React, { useState } from 'react'
import { useStyles } from './FlyOurOnboardingWhatAreYouDoingHere.styles'
import { Typography } from '@mui/material'
import {
  CaraouselData,
  ExternalLink,
  ModalConfirmV2,
  ModalSizeVariants,
  NoteV2,
} from '@labrav/react-components'
import { Carousel } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAws } from '@fortawesome/free-brands-svg-icons'
import { parseLabel } from '../FlyOutOnboardingAdhere/FlyOutOnboardingAdhere'
import { useScreenSize } from '@labrav/common'
export interface WhatAreYouDoingHereData {
  heading: string
  description: string
  secondaryText?: string
  video?: string
  linkText?: string
  note?: string
}
export interface WhatAreYouDoingHereProps {
  sectionData: WhatAreYouDoingHereData
  images: CaraouselData[]
  thumbnailImage: string
}

export const WhatAreYouDoingHere: React.FC<WhatAreYouDoingHereProps> = ({
  sectionData,
  images,
  thumbnailImage,
}) => {
  const [index, setIndex] = useState(0)
  const [indexModal, setIndexModal] = useState(0)
  const [open, setOpen] = useState(false)
  const hasNote = !!sectionData?.note
  const { classes } = useStyles()
  const handleImageClick = (index: number) => {
    setIndexModal(index)
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const noOps = () => void 0

  const { screenWidth } = useScreenSize()

  const handleThumnailClick = () => {
    const newWind = window.open(
      sectionData.video,
      '_blank',
      'noopener noreferrer'
    )
    if (newWind) {
      newWind.opener = null
    }
  }
  const maxWidth = screenWidth <= 1280 ? screenWidth * 0.7 : screenWidth * 0.65
  return (
    <div className={classes.rootContainer} data-testid="what-are-you-doing">
      <div className={classes.descriptionContainer}>
        <Typography
          className={classes.heading}
          data-testid="heading-what-are-you-doing"
        >
          {sectionData.heading}
        </Typography>
        <Typography
          className={classes.description}
          data-testid="description-what-are-you-doing"
        >
          {parseLabel(sectionData.description || '').map((part, idx) => (
            <React.Fragment key={idx}>{part}</React.Fragment>
          ))}
        </Typography>
        {sectionData.secondaryText && (
          <Typography
            className={classes.description}
            data-testid="secondary-what-are-you-doing"
          >
            {' '}
            {sectionData.secondaryText}
          </Typography>
        )}
        {sectionData?.note && <NoteV2 description={sectionData.note} />}
        {sectionData?.video && (
          <div
            className={classes.videoContainer}
            data-testid="video-what-are-you-doing"
          >
            <img
              className={classes.thumbnailImages}
              src={thumbnailImage}
              title="Labra FlyOut"
              alt={'what-are-you-doing-here'}
              onClick={handleThumnailClick}
            />
            <div data-testid="video-link-what-are-you-doing">
              <ExternalLink href={sectionData.video}>
                {sectionData.linkText}
              </ExternalLink>
            </div>
          </div>
        )}
      </div>
      <hr className={classes.divider} />
      <div
        className={classes.imageContainer}
        data-testid="carousel-what-are-you-doing"
      >
        <Carousel
          showHeading={true}
          carouselData={images}
          handleImageClick={handleImageClick}
          setCurrentIndex={setIndex}
          currentIndex={index}
          autoPlayInterval={4000}
          isCursorZoomIn={true}
        />
      </div>
      <ModalConfirmV2
        title={`${images[indexModal].heading}`}
        description={''}
        icon={
          <FontAwesomeIcon
            icon={faAws}
            style={{ height: '16px', width: '16px' }}
          />
        }
        content={
          <Carousel
            showHeading={false}
            carouselData={images}
            handleImageClick={handleClose}
            setCurrentIndex={setIndexModal}
            currentIndex={indexModal}
            isCursorZoomOut={true}
          />
        }
        open={open}
        titleAcceptButton={''}
        titleCancelButton={''}
        onDecline={handleClose}
        variant={ModalSizeVariants.xLarge}
        hideAcceptButton={true}
        hideCancelButton={true}
        maxWidth={`${maxWidth}px`}
        onAccept={noOps}
      />
    </div>
  )
}
